import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { T_SHIRT_SIZE_DEFAULT, T_SHIRT_SIZES  } from '../../config';
import css from './index.module.css';
import generalStyles from '../../design-language/general.module.css';

const CTA = ({ center, children, contrast, disabled, href, title, importance, onClick, size, target, type }) => {
  const Element = !!href ? 'a' : 'button';
  const wrapperClasses = classnames(
    css.cta,
    css[`cta${importance}`],
    css[`cta${size}`],
    {
      [generalStyles.uElementCenter]: center,
      [css.ctaContrast]: contrast,
      'ctaDisabled': disabled,
    }
  );

  return (
    <Element
      className={wrapperClasses}
      disabled={disabled}
      href={!disabled ? href : null }
      onClick={onClick}
      title={title}
      type={!href ? type : null}
      target={href ? target : null}
    >
      <span>{children}</span>
    </Element>
  )
};

CTA.propTypes = {
  center: PropTypes.bool,
  children: PropTypes.node.isRequired,
  contrast: PropTypes.bool,
  disabled: PropTypes.bool,
  href: PropTypes.string,
  importance: PropTypes.oneOf(['Primary', 'Secondary', 'Link']),
  onClick: PropTypes.func,
  size: PropTypes.oneOf(T_SHIRT_SIZES),
  target: PropTypes.oneOf([null, '_blank']),
  type: PropTypes.oneOf(['button', 'reset', 'submit']),
};

CTA.defaultProps = {
  center: false,
  contrast: false,
  disabled: false,
  href: null,
  importance: 'Primary',
  onClick: () => {},
  size: T_SHIRT_SIZE_DEFAULT,
  target: null,
  type: 'button',
};

export default CTA;
